/* eslint-disable react/destructuring-assignment */
import React, {Component, useEffect} from 'react';

import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import {batch, connect, useDispatch} from 'react-redux';

import * as deviceInfoActions from '@/actions/deviceInfoActions';
import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {Post, Get} from '@/api/request';
import StandalonePopUp from '@/components/popup/StandalonePopUp';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventCheckUpdateSystem, EventFirstTareService, EventLicenseService} from '@/constants/pubSubEnum';
import useUsb from '@/hooks/useUsb';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';
import {eventBusObject} from '@/observers/eventBus';

import './LicenseService.less';

const SHOW_CONSOLE_LOG = false;
// TODO: temporary solution to be able use the custom hook that handles the usb list api control
const withUseUSB = (Component) => {
  function useUsbList(props) {
    const dispatch = useDispatch();
    const {usbList, RefreshUsbList} = useUsb();

    useEffect(() => {
      batch(() => {
        if (usbList.length > 0) {
          dispatch(setupActions.usbOpenFor(APPDATA.USB_OPEN_FOR.IMPORT_LICENSE));
          dispatch(setupActions.usbProperties(usbList));
          window.location.href = APPDATA.USB_FILE_LIST_ADDRESS;
        }
      });
    }, [usbList]);

    return (
      <Component
        RefreshingUsbList={RefreshUsbList}
        UsbList={usbList}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }

  return useUsbList;
};
// TODO: need to break down this service component
@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
  licenseStatus: store.deviceInfoStore.licenseStatus,
  licenseType: store.deviceInfoStore.licenseType,
  clientID: store.deviceInfoStore.clientID,
  licenseActivationMode: store.deviceInfoStore.licenseActivationMode,
  isTrialAvailable: store.deviceInfoStore.isTrialAvailable,
  licenseDayLeftCheckDate: store.deviceInfoStore.licenseDayLeftCheckDate,
  licenseDayLeft: store.deviceInfoStore.licenseDayLeft,
  trialDuration: store.deviceInfoStore.trialDuration,
}))
class LicenseService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // IsFromHome: undefined,
      clientID: '',
      invalidClientID: true,
      ShowTrialModal: false,
      isDemoMode: false,
      getLicenseStatusInterval: 1000,
      isThrottled: false,
      popUp: {
        popUpVisible: false,
        popUpTitle: '',
        popUpText: '',
        popUpButton: undefined,
        hideCloseButton: false,
      },
    };
    this._bus = eventBusObject();

    this._statusLicensePolling = undefined;
    this._statusLicenseWhenRunningPolling = undefined;
    this._ismounted = true;

    this.successGetInitialStatusLicense = this.successGetInitialStatusLicense.bind(this);
    this.failedGetInitialStatusLicense = this.failedGetInitialStatusLicense.bind(this);
    this.successActivateLicenseManual = this.successActivateLicenseManual.bind(this);
    this.failedActivateLicenseManual = this.failedActivateLicenseManual.bind(this);
    this.successActivateTrial = this.successActivateTrial.bind(this);
    this.failedActivateTrial = this.failedActivateTrial.bind(this);
    this.successGetIsTrialAvailable = this.successGetIsTrialAvailable.bind(this);
    this.failedGetIsTrialAvailable = this.failedGetIsTrialAvailable.bind(this);
    this.successGetLicenseInfo = this.successGetLicenseInfo.bind(this);
    this.failedGetLicenseInfo = this.failedGetLicenseInfo.bind(this);
    this.successGetTrialLicenseDayLeft = this.successGetTrialLicenseDayLeft.bind(this);
    this.failedGetTrialLicenseDayLeft = this.failedGetTrialLicenseDayLeft.bind(this);
    this.successGetUSBDrive = this.successGetUSBDrive.bind(this);
    this.failedGetUSBDrive = this.failedGetUSBDrive.bind(this);
  }

  /**
   * Component Life Cycle Start
   */
  componentDidMount() {
    const {dispatch} = this.props;
    const {getLicenseStatusInterval} = this.state;
    this._ismounted = true;
    this._statusLicensePolling = setInterval(() => {
      this.setPollingLicense();
    }, getLicenseStatusInterval);
    // this.initialStatusLicense();

    // this._bus.publish("FirstTareService", {})

    const disableOnlineRadioButton = true;
    if (disableOnlineRadioButton) {
      dispatch(deviceInfoActions.updateLicenseActivationMode(APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE));
      // this.licenseModal({
      // 	licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE,
      // });
      // licenseMode = APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE;
    }
    // this.eventInitialLicense =
    this._bus.subscribe(EventLicenseService.initialLicenseService, (param) => this.initialStatusLicense(param));
    // this.eventLicenseInfo =
    this._bus.subscribe(EventLicenseService.LicenseInfoService, (param) => this.getAllLicenseInfo(param));
    this.eventLicenseModal = this._bus.subscribe(EventLicenseService.LicenseModalService, (param) =>
      this.licenseModal(param),
    );
    this.eventTrialLicenseModal = this._bus.subscribe(EventLicenseService.TrialLicenseModalService, (param) =>
      this.trialLicenseModal(param),
    );
    // this.eventActivateLicenseManual =
    this._bus.subscribe(EventLicenseService.ActivateLicenseManual, (param) => this.activateLicenseManual(param));
    // this.eventTrialLicenseDayLeftInfoService =
    this._bus.subscribe(EventLicenseService.TrialLicenseDayLeftInfoService, (param) =>
      this.getTrialLicenseDayLeft(param),
    );
  }

  componentWillUnmount() {
    this._ismounted = false;
    this.eventLicenseModal.unsubscribe();
    this.eventTrialLicenseModal.unsubscribe();
  }

  setPollingLicense = () => {
    clearInterval(this._statusLicensePolling);
    this._statusLicensePolling = undefined;
    this._statusLicensePolling = setInterval(() => {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.isPCRunning) {
        this._statusLicenseWhenRunningPolling = setInterval(() => {
          // eslint-disable-next-line react/destructuring-assignment
          if (!this.props.isPCRunning) {
            this.getAllLicenseInfo();
            clearInterval(this._statusLicenseWhenRunningPolling);
            this._statusLicenseWhenRunningPolling = undefined;
          }
        }, 1000);
      } else {
        this.getAllLicenseInfo();
      }
      if (SHOW_CONSOLE_LOG)
        consoleLog('Interval Get license Status cek', {
          // eslint-disable-next-line react/destructuring-assignment
          LicenseInterval: new Date(this.state.getLicenseStatusInterval).toISOString().slice(11, -1),
        });
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.getLicenseStatusInterval <= 23 * 60 * 60 * 1000) {
        let newInterval = new Date(new Date().setHours(24, 0, 0, 0)).getTime() - new Date().getTime();
        while (newInterval <= 0) {
          newInterval = new Date(new Date().setHours(24, 0, 0, 0)).getTime() - new Date().getTime();
        }
        if (this._ismounted) {
          this.setState(
            {
              getLicenseStatusInterval: newInterval,
            },
            () => {
              if (SHOW_CONSOLE_LOG)
                consoleLog('Interval Get license Status', {
                  // eslint-disable-next-line react/destructuring-assignment
                  LicenseInterval: new Date(this.state.getLicenseStatusInterval).toISOString().slice(11, -1),
                });
              this.setPollingLicense();
            },
          );
        }
      }
      // eslint-disable-next-line react/destructuring-assignment
    }, this.state.getLicenseStatusInterval);
  };

  initialStatusLicense = ({isShowTrialModal}) => {
    const param = {};
    const passingValue = {isShowTrialModal};
    Post(
      APPDATA.API.POST_INITIAL_LICENSE,
      param,
      this.successGetInitialStatusLicense,
      passingValue,
      (error, passingVariabel) => {
        if (SHOW_CONSOLE_LOG) consoleLog('initialStatusLicense exception', {error, passingVariabel});
      },
      this.failedGetInitialStatusLicense,
    );
  };

  successGetInitialStatusLicense = (response, passingVariabel) => {
    const {dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('successGetInitialStatusLicense', {response, passingVariabel});
    const {isShowTrialModal} = passingVariabel;
    // this._bus.publish(EventLicenseService.TrialLicenseModalService, { isButtonActivateDisable: false });
    if (response.data.Result !== undefined) {
      dispatch(deviceInfoActions.updateInitialLicenseInfo(response.data));

      const isDemo = !(
        (response.data.Result.Status === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
          response.data.Result.Type === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
        response.data.Result.Type === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
      );
      if (this._ismounted) {
        this.setState(
          {
            ShowTrialModal: isShowTrialModal,
            isDemoMode: isDemo,
          },
          () => {
            this.getLicenseInfo();
            this.getIsTrialAvailable(true);
          },
        );
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  failedGetInitialStatusLicense = (response, passingVariabel) => {
    if (SHOW_CONSOLE_LOG) consoleLog('failedGetInitialStatusLicense', {response, passingVariabel});
  };

  getIsTrialAvailable = (isStartUp) => {
    const param = {};
    const passingValue = isStartUp;
    if (SHOW_CONSOLE_LOG) consoleLog('getIsTrialAvailable', APPDATA.API.GET_IS_TRIAL_LICENSE_AVAILABLE);
    Get(
      APPDATA.API.GET_IS_TRIAL_LICENSE_AVAILABLE,
      param,
      this.successGetIsTrialAvailable,
      passingValue,
      () => {},
      this.failedGetIsTrialAvailable,
    );
  };

  successGetIsTrialAvailable = (response, passingVariabel) => {
    const {dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('successGetIsTrialAvailable', {response, passingVariabel});
    // this._bus.publish(EventLicenseService.TrialLicenseModalService, { isButtonActivateDisable: false });
    if (response.data !== undefined) {
      dispatch(deviceInfoActions.updateLicenseTrialAvailable(!response.data));
    }
    if (passingVariabel) {
      const {ShowTrialModal, isDemoMode} = this.state;
      if (ShowTrialModal && !response.data) this.trialLicenseModal({isButtonActivateDisable: false});
      else if (!isDemoMode && ShowTrialModal) {
        this._bus.publish(EventFirstTareService.FirstTareService, {});
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  failedGetIsTrialAvailable = (response, passingVariabel) => {
    if (SHOW_CONSOLE_LOG) consoleLog('failedGetIsTrialAvailable', {response, passingVariabel});
    // this.props.dispatch(setupActions.showAlert({ alertShow: true, alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_INFO, alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO }));
  };

  getAllLicenseInfo = () => {
    this.getLicenseInfo();
    this.getIsTrialAvailable(false);
  };

  getLicenseInfo = () => {
    const param = {};
    const passingValue = {};
    if (SHOW_CONSOLE_LOG) consoleLog('getLicenseInfo', APPDATA.API.GET_LICENSE_INFO);
    Get(
      APPDATA.API.GET_LICENSE_INFO,
      param,
      this.successGetLicenseInfo,
      passingValue,
      () => {},
      this.failedGetLicenseInfo,
    );
  };

  successGetLicenseInfo = (response, passingVariabel) => {
    const {dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('successGetLicenseInfo', {response, passingVariabel});
    // this._bus.publish(EventLicenseService.TrialLicenseModalService, { isButtonActivateDisable: false });
    if (response.data !== undefined) {
      dispatch(deviceInfoActions.updateLicenseInfo(response.data));
      const isDemo = !(
        (response.data.LicenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
          response.data.LicenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
        response.data.LicenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
      );
      if (SHOW_CONSOLE_LOG) consoleLog('successGetLicenseInfo isDemo', isDemo);
      if (this._ismounted) {
        this.setState({
          isDemoMode: isDemo,
        });
      }
      const {isThrottled} = this.state;
      if (!isThrottled) {
        // If not throttled, make the API call and set throttling state
        this._bus.publish(EventCheckUpdateSystem.CheckingVersionUpdate, {IsFromHome: true});
        this.setState({isThrottled: true});

        // Reset throttling state after threshold interval
        setTimeout(() => {
          this.setState({isThrottled: false});
        }, 3000);
      } else {
        console.log('Ignoring API call due to throttling');
      }
    }
  };

  failedGetLicenseInfo = (response, passingVariabel) => {
    const {dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('failedGetLicenseInfo', {response, passingVariabel});
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_INFO,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
      }),
    );
  };

  getTrialLicenseDayLeft = () => {
    const {licenseDayLeftCheckDate} = this.props;
    const param = {};
    const passingValue = {};
    if (SHOW_CONSOLE_LOG) consoleLog('getLicenseInfo', APPDATA.API.GET_LICENSE_INFO);
    const nowDate = new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'});
    if (licenseDayLeftCheckDate === undefined && licenseDayLeftCheckDate !== nowDate) {
      Get(
        APPDATA.API.GET_LICENSE_INFO,
        param,
        this.successGetTrialLicenseDayLeft,
        passingValue,
        () => {},
        this.failedGetTrialLicenseDayLeft,
      );
    } else {
      // eslint-disable-next-line no-lonely-if
      if (SHOW_CONSOLE_LOG) consoleLog('Failed get license info');
      // this.props.dispatch(setupActions.showAlert({ alertShow: true, alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_INFO, alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO }));
    }
  };

  successGetTrialLicenseDayLeft = (response, passingVariabel) => {
    const {dispatch, licenseDayLeftCheckDate} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('successGetTrialLicenseDayLeft', {response, passingVariabel});

    if (response.data !== undefined) {
      dispatch(deviceInfoActions.updateLicenseInfo(response.data));
      const nowDate = new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'});
      if (
        licenseDayLeftCheckDate === undefined &&
        licenseDayLeftCheckDate !== nowDate &&
        response.data.LicenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
        response.data.LicenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY
      ) {
        dispatch(deviceInfoActions.licenseDayLeftCheckDate(nowDate));

        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.LICENSE.ALLERT.TRIAL_DAY_LEFT.replace(
              '{NUMBER_OF_DAY}',
              response.data.NumberOfDaysLeft,
            ),
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  failedGetTrialLicenseDayLeft = (response, passingVariabel) => {
    if (SHOW_CONSOLE_LOG) consoleLog('failedGetTrialLicenseDayLeft', {response, passingVariabel});
  };

  onChangeLicenseMode = (e) => {
    const {dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('onChangeLicenseMode', e.target.value);
    dispatch(deviceInfoActions.updateLicenseActivationMode(e.target.value));
    this.licenseModal({
      licenseMode: e.target.value,
    });
  };

  onClickButtonLicenseActivationModal = (e) => {
    const {licenseActivationMode} = this.props;
    const {popUp} = this.state;

    switch (e.currentTarget.id) {
      case APPDATA.ACTIVATE:
        if (SHOW_CONSOLE_LOG) consoleLog('Button Activate clicked, mode:', licenseActivationMode);
        switch (licenseActivationMode) {
          case APPDATA.LICENSE_ACTIVATION_MODE.ONLINE:
            this.checkLicenseByClientId();
            break;

          case APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE: {
            const {RefreshingUsbList} = this.props;
            RefreshingUsbList();
            break;
          }

          case APPDATA.LICENSE_ACTIVATION_MODE.TRIAL:
            this.activateTrialLicense();
            break;
          default:
            break;
        }
        break;

      case APPDATA.CANCEL:
        if (SHOW_CONSOLE_LOG) consoleLog('Button CANCEL clicked, mode:', licenseActivationMode);
        break;
      default:
        break;
    }
    const newPopUp = {...popUp};
    newPopUp.popUpVisible = false;
    if (this._ismounted) {
      this.setState(
        {
          popUp: newPopUp,
        },
        () => {},
      );
    }
  };

  goToInfoPageOpenLicenseModal = () => {
    this.licenseModal({
      licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.TRIAL,
    });
    this.goToInfoPage();
  };

  activateLicenseManual = (param) => {
    const passingValue = param.LicenseFile;
    if (SHOW_CONSOLE_LOG) consoleLog(`activateLicenseManual param ${APPDATA.API.POST_ACTIVATE_LICENSE_MANUAL}`, param);
    Post(
      APPDATA.API.POST_ACTIVATE_LICENSE_MANUAL,
      param,
      this.successActivateLicenseManual,
      passingValue,
      (error, passingVariabel) => {
        if (SHOW_CONSOLE_LOG) consoleLog('activateLicenseManual exception', {error, passingVariabel});
      },
      this.failedActivateLicenseManual,
    );
  };

  failedActivateLicenseManual = (response, passingVariabel) => {
    const {licenseActivationMode, dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('failedActivateLicenseManual', {licenseActivationMode, response, passingVariabel});
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_OFFLINE,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.goToInfoPage();
  };

  successActivateLicenseManual = (response, passingVariabel) => {
    const {licenseActivationMode, dispatch} = this.props;
    // Error: "InvalidDevice";
    // Status: "NoLicense";
    // Type: "Instrument";
    // Url: "http://localhost:5002";
    switch (response.data.Error) {
      case APPDATA.FIELD_NAME.LICENSE.ERROR.None:
        if (SHOW_CONSOLE_LOG)
          consoleLog(
            `successActivateLicenseManual` +
              ` Activation Mode : ${licenseActivationMode}, Path file : ${passingVariabel}`,
            {response, passingVariabel},
          );
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.LICENSE.ALLERT.SUCCESS,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
          }),
        );
        break;
      case APPDATA.FIELD_NAME.LICENSE.ERROR.Invalid:
        if (SHOW_CONSOLE_LOG)
          consoleLog(
            `Failed successActivateLicenseManual` +
              ` Activation Mode : ${licenseActivationMode}, Path file : ${passingVariabel}`,
            {response, passingVariabel},
          );
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_OFFLINE_INVALID,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      case APPDATA.FIELD_NAME.LICENSE.ERROR.InvalidDevice:
        if (SHOW_CONSOLE_LOG)
          consoleLog(
            `Failed successActivateLicenseManual` +
              ` Activation Mode : ${licenseActivationMode}, Path file : ${passingVariabel}`,
            {response, passingVariabel},
          );
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_OFFLINE_INVALID_DEVICE,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
      default:
        if (SHOW_CONSOLE_LOG)
          consoleLog(
            `Failed successActivateLicenseManual` +
              ` Activation Mode : ${licenseActivationMode}, Path file : ${passingVariabel}`,
            response,
            passingVariabel,
          );
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_OFFLINE,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        break;
    }
    this.initialStatusLicense({isShowTrialModal: false});
    this.goToInfoPage();
  };

  // eslint-disable-next-line class-methods-use-this, react/sort-comp
  goToInfoPage() {
    window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
  }

  // ---------------------------------------- TRIAL MODE ----------------------------
  activateTrialLicense() {
    const param = {
      clientName: 'Formulatrix',
    };
    const passingValue = {};
    if (SHOW_CONSOLE_LOG) consoleLog('activateTrialLicense', APPDATA.API.GET_LICENSE_INFO);
    Post(
      APPDATA.API.POST_ACTIVATE_LICENSE_TRIAL,
      param,
      this.successActivateTrial,
      passingValue,
      () => {},
      this.failedActivateTrial,
    );
  }

  successActivateTrial = (response, passingVariabel) => {
    const {licenseActivationMode, dispatch} = this.props;
    if (response.data) {
      if (SHOW_CONSOLE_LOG)
        consoleLog(`successActivateTrial Activation Mode : ${licenseActivationMode}`, {response, passingVariabel});
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.LICENSE.ALLERT.TRIAL_SUCCESS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      this.initialStatusLicense({isShowTrialModal: true});
      this._bus.publish(EventFirstTareService.FirstTareService, {});
    } else {
      if (SHOW_CONSOLE_LOG)
        consoleLog(`Failed successActivateTrial Activation Mode : ${licenseActivationMode}`, {
          response,
          passingVariabel,
        });
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    }
  };

  failedActivateTrial = (response, passingVariabel) => {
    const {licenseActivationMode, dispatch} = this.props;
    if (SHOW_CONSOLE_LOG)
      consoleLog(`failedActivateTrial Activation Mode : ${licenseActivationMode}`, {response, passingVariabel});
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };

  closePopUp = () => {
    const {popUp} = this.props;
    // var newPopUp = {
    //     popUpVisible: false,
    //     popUpTitle: "",
    //     popUpText: "",
    //     popUpButton: undefined,
    // };
    const newPopUp = {...popUp};
    newPopUp.popUpVisible = false;
    if (this._ismounted) {
      this.setState(
        {
          popUp: newPopUp,
        },
        () => {},
      );
    }
  };

  generateButton = () => {
    const {popUp} = this.state;
    const button = popUp.popUpButton
      ? popUp.popUpButton.map((button) => {
          // eslint-disable-next-line no-nested-ternary
          const classButton = button.isPrimaryButton
            ? `primaryButton no-outline ${button.className}`
            : button.className
            ? `${button.className} no-outline `
            : 'secondaryButton no-outline ';
          return (
            <Button
              id={button.id}
              key={button.id}
              bsSize="large"
              className={classButton}
              onClick={button.onClick}
              disabled={button.disabled}
            >
              {button.label.toUpperCase()}
            </Button>
          );
        })
      : '';
    return button;
  };

  // ---------------------------------------- ONLINE MODE ----------------------------
  checkLicenseByClientId() {
    const {clientID} = this.state;
    const {licenseActivationMode, dispatch} = this.props;
    if (SHOW_CONSOLE_LOG)
      consoleLog(`checkLicenseByClientId Activation Mode : ${licenseActivationMode}, Client ID : ${clientID}`);
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.LICENSE.ALLERT.SUCCESS,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
      }),
    );
    // this.initialStatusLicense({ isShowTrialModal: true });
  }

  // ---------------------------------------- OFFLINE MODE ----------------------------
  /**
   * @deprecated
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  checkAvailableFlash() {
    setTimeout(() => {
      const params = {
        params: {
          partition: APPDATA.CONFIGURATION.USB_FLASH.PARTITION_USB_FLASH,
        },
      };
      const passingVariabel = {};
      Get(APPDATA.API.GET_USB_DRIVE, params, this.successGetUSBDrive, passingVariabel, this.failedGetUSBDrive);
    }, 500);
  }

  /**
   * @deprecated
   * @param {*} self
   * @param {*} response
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  successGetUSBDrive(response) {
    if (this._stopProcess) return;

    const contentResponse = response.data.details;
    // go to next step
    if (response.data.details.length > 0) {
      this._stopProcess = true;
      if (SHOW_CONSOLE_LOG) consoleLog('successGetUSBDrive', response);
      if (SHOW_CONSOLE_LOG) consoleLog('USB IS READY, SHOW LIST NOW');

      if (typeof this._getUSBPooling !== 'undefined') {
        clearInterval(this._getUSBPooling);
        this._getUSBPooling = undefined;
      }
      this.props.dispatch(setupActions.usbOpenFor(APPDATA.USB_OPEN_FOR.IMPORT_LICENSE));
      this.props.dispatch(setupActions.usbProperties(contentResponse));
      this.props.dispatch(loadingActions.showLoading(false));
      this.goToUSBFileList();
    } else {
      this._stopProcess = false;
      // consoleLog("USB NOT READY, MOUNT NOW, AND GET FILE LIST", this._stopProcess);
      if (!this._stopProcess) this.checkAvailableFlash();
    }
  }

  /**
   * @deprecated
   * @param {*} self
   * @param {*} error
   */
  // eslint-disable-next-line class-methods-use-this
  failedGetUSBDrive(error) {
    // will show error from request
    // force close
    // usb not found
    consoleError('Error : Failed get USB Drive', error);
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.EXPORT_IMPORT.FAILED_GET_FLASH_DRIVE, // response.message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.props.dispatch(loadingActions.showLoading(false));
  }

  /**
   * @deprecated
   */
  // eslint-disable-next-line class-methods-use-this, react/no-unused-class-component-methods
  goToUSBFileList() {
    window.location.href = APPDATA.USB_FILE_LIST_ADDRESS;
  }

  trialLicenseModal({isButtonActivateDisable}) {
    const {licenseStatus, licenseType, isTrialAvailable, dispatch} = this.props;
    if (SHOW_CONSOLE_LOG) consoleLog('trialLicenseModal', {licenseStatus, licenseType, isTrialAvailable});
    if (APPDATA.CONFIGURATION.ENABLED_TRIAL_LICENSE_MODAL) {
      // if (licenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.NO_LICENSE && licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.UNKNOWN) {
      if (isTrialAvailable) {
        dispatch(deviceInfoActions.updateLicenseActivationMode(APPDATA.LICENSE_ACTIVATION_MODE.TRIAL));
        const popUpButton = [
          {
            id: APPDATA.ACTIVATE,
            label: APPDATA.ACTIVATE,
            isPrimaryButton: true,
            onClick: this.goToInfoPageOpenLicenseModal,
            disabled: isButtonActivateDisable,
          },
          // {
          //   id: APPDATA.CANCEL,
          //   label: APPDATA.LATER,
          //   isPrimaryButton: false,
          //   onClick: this.onClickButtonLicenseActivationModal,
          // },
        ];

        const newPopUp = {
          popUpVisible: true,
          popUpTitle: APPDATA.MESSAGES.LICENSE.MODAL_TRIAL.TITLE,
          popUpText: APPDATA.MESSAGES.LICENSE.MODAL_TRIAL.TEXT,
          popUpButton,
          hideCloseButton: licenseStatus !== 'Active' && licenseType !== 'Instrument',
        };
        if (this._ismounted) {
          this.setState(
            {
              popUp: newPopUp,
            },
            () => {},
          );
        }
      }
    }
  }

  licenseModal({licenseMode}) {
    const {licenseStatus, licenseType, isTrialAvailable, trialDuration} = this.props;
    const {invalidClientID} = this.state;
    let isButtonActivatedDisable = false;
    // var disableTrialRadioButton = licenseStatus !== APPDATA.FIELD_NAME.LICENSE.STATUS.NO_LICENSE;
    const disableTrialRadioButton = !isTrialAvailable;
    if (licenseMode === APPDATA.LICENSE_ACTIVATION_MODE.ONLINE && invalidClientID) {
      isButtonActivatedDisable = true;
    }
    // consoleLog(APPDATA.LICENSE_ACTIVATION_MODE.ONLINE, {invalidClientID, isButtonActivatedDisable, disableTrialRadioButton, licenseStatus});
    const popUpButton = [
      {
        id: APPDATA.ACTIVATE,
        label: APPDATA.ACTIVATE,
        isPrimaryButton: true,
        onClick: this.onClickButtonLicenseActivationModal,
        disabled: isButtonActivatedDisable,
      },
      // {
      //   id: APPDATA.CANCEL,
      //   label: APPDATA.CANCEL,
      //   isPrimaryButton: false,
      //   onClick: this.onClickButtonLicenseActivationModal,
      // },
    ];

    const newPopUp = {
      popUpVisible: true,
      popUpTitle: APPDATA.MESSAGES.LICENSE.MODAL.TITLE,
      popUpText: (
        <div>
          <div className="">{APPDATA.MESSAGES.LICENSE.MODAL.TEXT}</div>
          <div className="row ">
            <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
              <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                <div className="col-xs-1 col-md-1 col-lg-1 col-xl-1">
                  <input
                    id={APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE}
                    value={APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE}
                    checked={licenseMode === APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE}
                    name="licenseMode"
                    type="radio"
                    onChange={this.onChangeLicenseMode}
                  />
                </div>
                <div className="col-xs-11 col-md-11 col-lg-11 col-xl-11">
                  {APPDATA.MESSAGES.LICENSE.ACTIVATION_MODE.OFFLINE.TITLE}
                </div>
              </div>
              {licenseMode === APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE ? (
                <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="col-xs-1 col-md-1 col-lg-1 col-xl-1" />
                  <div className="col-xs-11 col-md-11 col-lg-11 col-xl-11">
                    <span className="spanStyleTextView no-padding">
                      {newLineHtml(APPDATA.MESSAGES.LICENSE.ACTIVATION_MODE.OFFLINE.TEXT)}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
            {/* {isTrialAvailable ? ( */}
            <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
              <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                <div className="col-xs-1 col-md-1 col-lg-1 col-xl-1">
                  <input
                    id={APPDATA.LICENSE_ACTIVATION_MODE.TRIAL}
                    value={APPDATA.LICENSE_ACTIVATION_MODE.TRIAL}
                    checked={licenseMode === APPDATA.LICENSE_ACTIVATION_MODE.TRIAL}
                    name="licenseMode"
                    type="radio"
                    onChange={this.onChangeLicenseMode}
                    disabled={disableTrialRadioButton}
                  />
                </div>
                <div
                  className={
                    disableTrialRadioButton
                      ? 'col-xs-11 col-md-11 col-lg-11 col-xl-11 disableRadioButtonText'
                      : 'col-xs-11 col-md-11 col-lg-11 col-xl-11'
                  }
                >
                  {APPDATA.MESSAGES.LICENSE.ACTIVATION_MODE.TRIAL.TITLE}
                </div>
              </div>
              {licenseMode === APPDATA.LICENSE_ACTIVATION_MODE.TRIAL ? (
                <div className="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="col-xs-1 col-md-1 col-lg-1 col-xl-1" />
                  <div className="col-xs-11 col-md-11 col-lg-11 col-xl-11">
                    <span className="spanStyleTextView no-padding">
                      {newLineHtml(
                        APPDATA.MESSAGES.LICENSE.ACTIVATION_MODE.TRIAL.TEXT.replace('{NUMBER_OF_DAY}', trialDuration),
                      )}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
            {/* ) : (
                            <React.Fragment></React.Fragment>
                        )} */}
          </div>
        </div>
      ),
      popUpButton,
      hideCloseButton: licenseStatus !== 'Active' && licenseType !== 'Instrument',
    };
    if (this._ismounted) {
      this.setState(
        {
          popUp: newPopUp,
        },
        () => {},
      );
    }
  }

  render() {
    const {popUp} = this.state;
    return (
      <StandalonePopUp
        isPopUpVisible={popUp.popUpVisible}
        contents={{
          popUpTitle: popUp.popUpTitle,
          popUpBody: popUp.popUpText,
          popUpFooter: (
            <div className="row">
              <div className="buttondiv">{this.generateButton()}</div>
            </div>
          ),
        }}
        onClose={this.closePopUp}
        hideCloseButton={popUp.hideCloseButton}
      />
    );
  }
}

LicenseService.propTypes = {
  dispatch: PropTypes.func,
  RefreshingUsbList: PropTypes.func,
  isPCRunning: PropTypes.bool,
  licenseDayLeftCheckDate: PropTypes.any,
  licenseStatus: PropTypes.any,
  licenseType: PropTypes.any,
  isTrialAvailable: PropTypes.bool,
  licenseActivationMode: PropTypes.any,
  popUp: PropTypes.object,
  trialDuration: PropTypes.any,
};

LicenseService.defaultProps = {
  dispatch: () => {},
  RefreshingUsbList: () => {},
  isPCRunning: false,
  licenseDayLeftCheckDate: null,
  licenseStatus: null,
  licenseType: null,
  isTrialAvailable: false,
  licenseActivationMode: null,
  popUp: {},
  trialDuration: null,
};

export default withUseUSB(LicenseService);
